import axios from "axios";
import qs from "qs";
import type { SessionClient } from "@phurshell/psiapp-frontend-core/domain";
import {
  ApiServiceImpl,
  AxiosHttpClient,
  setupInterceptors,
} from "@phurshell/psiapp-frontend-core/infra";
import { SessionClientAdapter } from "@/app/adapters/SessionClientAdapter";
import {
  authTokenStorageClient,
  sessionStorageClient,
  userInfoStorageClient,
} from "./storage";
import { mockInterceptor } from "./mockInterceptor";

export const sessionClient: SessionClient = new SessionClientAdapter(
  sessionStorageClient,
  authTokenStorageClient,
  userInfoStorageClient,
);

const apiBaseUrl = `${process.env.VUE_APP_API_BASE_URL}api/`;

// Instância montada manualmente (em vez de createAxiosClient) só pra poder
// registrar o mockInterceptor ANTES do successInterceptor/errorInterceptor do
// core — ele precisa do AxiosResponse cru (response.config.url, response.data.data),
// e o successInterceptor já achata isso. Se o createAxiosClient do core mudar de
// configuração (baseURL/timeout/headers/paramsSerializer), replicar aqui também.
const axiosClient = axios.create({
  baseURL: apiBaseUrl,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  paramsSerializer: (params) =>
    qs.stringify(params, { arrayFormat: "brackets", skipNulls: true }),
});
axiosClient.interceptors.response.use(mockInterceptor);
setupInterceptors(axiosClient, sessionClient);

const httpClient = new AxiosHttpClient(axiosClient);
export const api = new ApiServiceImpl(httpClient);
